import React, { useEffect, useState } from "react";
import "./dev.css";
// import HouseDetails from "../../components/ui/HouseDetails";
import { Btn, FormSearch, Goback, SuccessComp } from "../../utils/utils";
// import SearchComp from "../../utils/search-comp";
import { Edit, Trash, UserAdd } from "iconsax-react";
import SwiperComp from "../../components/swiper/Swiper";
import DeletePopup from "../../utils/DeletePopup";
import { useNavigate } from "react-router-dom";
import { AxiosAuthGet, AxiosAuthRealDel } from "../../api/api";
import Loading from "../../components/ui/Loading";

const ViewProperty = () => {
  const property = JSON.parse(localStorage.getItem("singleProp"));
  const [cusData, setCusData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  // const [cusDumData, setCusDumData] = useState([1,2,3,4]);
  const [isCusLoad, setIsCusLoad] = useState(false);
  const [isPropLoad, setIsPropLoad] = useState(false);
  const [isDelLoad, setIsDelLoad] = useState(false);
  const [sucMsg, setSucMsg] = useState("");
  const cusUrl = `developer/customers/?estate_id=${property?.estate?.id}&property_id=${property?.id}&page=1&page_size=20`;
  const url = `developer/properties/${property.id}/`;

  const navigate = useNavigate();
  const [isDelete, setIsDelete] = useState(false);

  const clickDelete = () => {
    setIsDelete(!isDelete);
  };

  const addCus = () => {
    navigate("/dev_dash/customers/add");
  };

  const getCus = () => {
    setIsCusLoad(true);
    AxiosAuthGet(cusUrl)
      .then((res) => {
        // console.log(res);
        setCusData(res?.data);
        setIsCusLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsCusLoad(false);
      });
  };
  const getProp = () => {
    setIsPropLoad(true);
    AxiosAuthGet(url)
      .then((res) => {
        // console.log(res);
        setPropertyData(res?.data);
        setIsPropLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsPropLoad(false);
      });
  };

  useEffect(() => {
    getCus();
    getProp();
    // eslint-disable-next-line
  }, []);

  const clickView = (item) => {
    localStorage.setItem("singleCus", JSON.stringify(item));
    navigate("/dev_dash/customers/view");
  };

  const clickEdit = (item) => {
    localStorage.setItem("editProp", JSON.stringify(item));
    navigate("/dev_dash/property/property-add");
  };

  const deleteProp = () => {
    // console.log(deleteUrl);
    setIsDelLoad(true);
    AxiosAuthRealDel(url)
      .then((res) => {
        // console.log(res);
        setSucMsg(res.message);
        setTimeout(() => {
          setSucMsg("");
          navigate("/dev_dash/property");
        }, 2000);
        setIsDelLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsDelLoad(false);
      });
  };

  return isPropLoad ? (
    <Loading />
  ) : (
    <div className="dev_prop_view">
      <DeletePopup
        isDelete={isDelete}
        setIsDelete={setIsDelete}
        text={propertyData?.name}
        delFunc={deleteProp}
        loading={isDelLoad}
      />
      <SuccessComp message={sucMsg} />
      <div className="top_head">
        <Goback goText={"Property Details"} />
        <FormSearch placeholder={"Search"} />
      </div>
      <div className="view_body">
        <div className="view_body_head">
          <div className="view_body_left">
            <h2
              className="btn_style"
              style={{
                background: propertyData?.isVerified ? "#60DB41" : "#F08228",
                color: propertyData?.isVerified ? "white" : "white",
              }}
            >
              {propertyData?.isVerified ? "Verified" : "Not Verified"}
            </h2>
            <h3>{propertyData?.propertyType}</h3>
            <p>{propertyData?.address}</p>
          </div>
          <div className="view_body_right">
            {/* <h4>
              $500,000/ <span> annum</span>
            </h4> */}
          </div>
        </div>
        <div className="view_btn_cont">
          <Btn
            btnClick={addCus}
            btnText={"Add Customer"}
            leftIcon={<UserAdd size="24" color="white" />}
            btnClass={"home-btn"}
          />
          <Btn
            btnClick={() => clickEdit(propertyData)}
            btnText={"Edit Property"}
            leftIcon={<Edit size="24" color="#737475" />}
            btnClass={"btn_gray"}
          />
          <Btn
            btnClick={clickDelete}
            btnText={"Delete"}
            leftIcon={<Trash size="24" color="#FF0000" />}
            btnClass={"btn_error"}
          />
        </div>
        <div className="view_img_cont">
          <SwiperComp images={propertyData?.pictures} />
        </div>
        <div className="prop_det_cont">
          <p style={{ textTransform: "capitalize" }}>{propertyData?.name}</p>
          <p>
            Estate: <span>{propertyData?.estate?.name}</span>
          </p>
          {propertyData?.propertyType === "Land" &&
            propertyData?.blocks?.map((item, idx) => {
              return (
                <div key={idx} className="prop_blocks">
                  <p>
                    {item?.blockName}:{" "}
                    <span>
                      {item?.allPlots?.length} plots • 
                      {Number(item?.sizePerPlot).toLocaleString()} sqm each • ₦
                      {item?.pricePerPlot.toLocaleString()}/plot
                    </span>
                  </p>
                  <p>
                    Available:{" "}
                    <span>
                      {item?.availablePlots?.map((item, idx) => {
                        return <span key={idx}>{item + " "}</span>;
                      })}
                    </span>
                  </p>
                </div>
              );
            })}
          {propertyData?.propertyType === "Building" && (
            <div className="prop_desc">
              <h3>Amenities</h3>
              {propertyData?.amenities?.map((item, idx) => {
                return <p key={idx}>{item}</p>;
              })}
            </div>
          )}
        </div>
        <div className="prop_det_cont cus_cont">
          <div className="cus_ass_head">
            <h4>Customers Assigned</h4>
          </div>
          {!isCusLoad && (
            <>
              {cusData?.length <= 0 && (
                <p>No customers assigned to this property yet.</p>
              )}
              {cusData?.length > 0 && (
                <div class="table-wrapper">
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th className="action-col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cusData?.map((item, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{item?.name}</td>
                            <td>{item?.phoneNumber}</td>
                            <td>{item?.email}</td>
                            <td
                              className="action-col"
                              onClick={() => clickView(item)}
                            >
                              View
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewProperty;
